// extracted by mini-css-extract-plugin
export default {"container":"Countdown_container__DbDGL","image":"Countdown_image__hXQ-w","fadeInOut":"Countdown_fadeInOut__uXNUL"};